<template>
  <ActivityHistoryTable
    :title="text.detail.tabPanels.shipping.title"
    :subtitle="text.detail.tabPanels.shipping.subtitle"
    :loading="loading"
    :rows="rows"
    :loading-text="text.detail.shipping.loading"
    :empty-text="text.detail.shipping.empty"
    :headers="text.detail.shipping.table.headers"
    :row-fallback="text.detail.shipping.fallback"
  />
</template>

<script>
import expenseReceiptsService from '@/services/expenseReceipts';
import { extractCollection } from '@/utils/dataNormalization';
import { formatDateTimeShort } from '@/utils/datePresentation';
import ActivityHistoryTable from '@/components/common/ActivityHistoryTable.vue';
import { useDomainText } from '@/composables/text/useDomainText';

const { catalog: text } = useDomainText('expenseReceipts');

export default {
  name: 'ExpenseReceiptDetailTabShipping',
  components: {
    ActivityHistoryTable,
  },
  props: {
    expenseReceipt: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      text,
      loading: false,
      rows: [],
      requestToken: 0,
    };
  },
  computed: {
    expenseReceiptId() {
      return Number(this.expenseReceipt?.id || 0);
    },
  },
  watch: {
    expenseReceiptId: {
      immediate: true,
      handler() {
        this.loadShipping();
      },
    },
  },
  methods: {
    async loadShipping() {
      const expenseReceiptId = Number(this.expenseReceiptId || 0);
      if (expenseReceiptId <= 0) {
        this.rows = [];
        return;
      }

      this.loading = true;
      const token = this.requestToken + 1;
      this.requestToken = token;

      try {
        const response = await expenseReceiptsService.shippingIndex(expenseReceiptId, { per_page: 200 });
        if (token !== this.requestToken) {
          return;
        }

        this.rows = extractCollection(response)
          .map((row) => this.mapShippingRow(row))
          .filter((row) => row !== null);
      } catch (error) {
        if (token === this.requestToken) {
          this.rows = [];
        }
      } finally {
        if (token === this.requestToken) {
          this.loading = false;
        }
      }
    },
    mapShippingRow(raw) {
      if (!raw || typeof raw !== 'object') {
        return null;
      }

      const statusLabel = String(raw.status_label || raw.status || '').trim();
      const stageLabel = String(raw.stage_label || raw.stage_key || '').trim();
      const eventLabel = [statusLabel, stageLabel].filter((part) => part !== '').join(' · ');
      const dateSource = raw.sent_at || raw.created_at || raw.date_label;

      return {
        id: Number(raw.id || 0) || `shipping-${Date.now()}`,
        date_label: formatDateTimeShort(dateSource, { fallback: this.text.detail.shipping.fallback.date }),
        module_label: String(raw.channel_label || this.text.detail.shipping.fallback.module).trim() || this.text.detail.shipping.fallback.module,
        event_label: eventLabel !== '' ? eventLabel : this.text.detail.shipping.fallback.event,
        description_label: String(raw.description_label || raw.subject || this.text.detail.shipping.fallback.description).trim()
          || this.text.detail.shipping.fallback.description,
        actor_label: String(raw.actor_label || raw.requested_by_name || this.text.detail.shipping.fallback.actor).trim()
          || this.text.detail.shipping.fallback.actor,
      };
    },
  },
};
</script>
